import { Configuration, StoresApi } from '@/api';
import CustomToast from '@/components/CustomToast';
import PageHeader from '@/components/PageHeader';
import { StoreCreate } from '@/models/Store';
import Breadcrumbs from '@/modules/admin/components/Breadcrumbs';
import StoreForm from '@/modules/admin/components/StoreForm';
import { RetailerStoreListPath } from '@/modules/admin/paths';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';

const StoreAdd = () => {
  const { retailerId } = useParams();

  const navigate = useNavigate();

  const storesApi = new StoresApi(new Configuration(useAuth));

  const handleOnSubmit = async (store: StoreCreate): Promise<void> => {
    if (!retailerId) return;

    store.retailerId = retailerId;

    try {
      await storesApi.createStore(store);

      toast.custom((t) => (
        <CustomToast
          id={t.id}
          message={`Store "${store.name}" created successfully!`}
          visible={t.visible}
        />
      ));

      navigate(RetailerStoreListPath.withRetailerId(retailerId));
    } catch (error) {
      console.error('Failed to create store:', error);
    }
  };

  return (
    <>
      <Breadcrumbs />

      <PageHeader title="Create Store" />

      <div className="w-full bg-white mx-auto rounded-lg shadow p-6 lg:p-12">
        <StoreForm onSubmit={handleOnSubmit} retailerId={retailerId} />
      </div>
    </>
  );
};

export default StoreAdd;
